module.exports = __webpack_public_path__ + "front/img/kv.8af301a0.jpg";